var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"li-image",style:(_vm.style),on:{"click":_vm._click}},[_c('img',{staticClass:"li-image_img",style:({ objectFit: _vm.objectFit }),attrs:{"src":_vm.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }